export const FETCH_DICTIONARY_START = "FETCH_DICTIONARY_START";
export const FETCH_DICTIONARY_SUCCESS = "FETCH_DICTIONARY_SUCCESS";
export const FETCH_DICTIONARY_FAILED = "FETCH_DICTIONARY_FAILED";
export const API_ERROR = "API_ERROR";
export const ADD_NEW_ITEM = "ADD_NEW_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const ADD_ITEM_TO_ACTIONS = "ADD_ITEM_TO_ACTIONS";
export const ADD_ITEM_TO_MARKUPS = "ADD_ITEM_TO_MARKUPS";
export const ADD_ITEM_TO_EXCHANGES = "ADD_ITEM_TO_EXCHANGES";
export const ADD_ITEM_TO_CALL_STATUS = "ADD_ITEM_TO_CALL_STATUS";
export const ADD_ITEM_TO_COUNTRIES = "ADD_ITEM_TO_COUNTRIES";
export const REMOVE_ITEM_FROM_ACTIONS = "REMOVE_ITEM_FROM_ACTIONS";
export const REMOVE_ITEM_FROM_MARKUP = "REMOVE_ITEM_FROM_MARKUP";
export const REMOVE_ITEM_FROM_COUNTRIES = "REMOVE_ITEM_FROM_COUNTRIES";
export const REMOVE_ITEM_FROM_EXCHANGES = "REMOVE_ITEM_FROM_EXCHANGES";
export const UPDATE_ACTION_START = "UPDATE_ACTION_START";
export const UPDATE_MARKUP_START = "UPDATE_MARKUP_START";
export const UPDATE_ACTION_SUCCESS = "UPDATE_ACTION_SUCCESS";
export const UPDATE_MARKUP_SUCCESS = "UPDATE_MARKUP_SUCCESS";
export const UPDATE_EXCHANGE_START = "UPDATE_EXCHANGE_START";
export const UPDATE_EXCHANGE_SUCCESS = "UPDATE_EXCHANGE_SUCCESS";
export const UPDATE_CALL_STATUS_START = "UPDATE_CALL_STATUS_START";
export const UPDATE_CALL_STATUS_SUCCESS = "UPDATE_CALL_STATUS_SUCCESS";
export const UPDATE_COUNTRY_START = "UPDATE_COUNTRY_START";
export const UPDATE_COUNTRY_SUCCESS = "UPDATE_COUNTRY_SUCCESS";
export const EDIT_CLEAR = "EDIT_CLEAR";
export const ADD_CLEAR = "ADD_CLEAR";
export const CLEAR_DELETE_MODAL = "CLEAR_DELETE_MODAL";
export const UPDATE_PRODUCTS_START = "UPDATE_PRODUCTS_START";
export const UPDATE_PRODUCTS_SUCCESS = "UPDATE_PRODUCTS_SUCCESS";
export const UPDATE_PRODUCTS_FAILED = "UPDATE_PRODUCTS_FAILED";

export const ADD_PRODUCT_START = "ADD_PRODUCT_START";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILED = "ADD_PRODUCT_FAILED";
